import React, { useEffect, useState } from "react";
import { Col, Row, Typography } from "antd";
import styled from "styled-components";
import { InfoBox, HeaderImage } from "@bindeleddet/core/components";
import { Article } from "@bindeleddet/core/types";
import axios from "axios";
import fallback from "assets/images/fallbackImg.png";
import ArticlesImage from "assets/images/headerImage/EventsImage.png";

const { Title } = Typography;

// @bindeleddet/core's InfoBox hardcodes an asymmetric inline padding
// (10px top, 32px bottom) on its button, pushing the label upward.
// Needs a core-side fix; overriding here (inline style beats plain CSS, hence
// !important) for now.
const StyledInfoBoxRow = styled(Row)`
  .ant-btn {
    padding: 10px 30px !important;
  }
`;

const Articles: React.FC = () => {
  const [articles, setArticles] = useState<Article[]>([]);
  const [loading, setLoading] = useState<boolean>(true);

  const stripHtml = (html: string) => {
    const tmp = document.createElement("DIV");
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || "";
  };

  useEffect(() => {
    axios
      .get<Article[]>("/website-contents/articles/")
      .then(response => {
        setArticles(response.data);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  return (
    <>
      <HeaderImage imageLink={ArticlesImage} alt="ArticlesImage" header="Nyheter" />
      <Row justify="center" style={{ padding: "3em 5%", width: "100%" }}>
        {loading ? (
          <Col span={24} style={{ textAlign: "center" }}>
            <Title level={4}>Laster artikler...</Title>
          </Col>
        ) : articles.length === 0 ? (
          <Col span={24} style={{ textAlign: "center" }}>
            <Title level={4}>Ingen artikler funnet</Title>
          </Col>
        ) : (
          <StyledInfoBoxRow justify="center" style={{ width: "100%" }} gutter={[48, 48]}>
            {articles.map(article => (
              <Col key={article.id}>
                <InfoBox
                  imageLink={article.big_image ?? fallback}
                  imageAlt=""
                  title={article.title}
                  text={`${stripHtml(article.content).slice(0, 100)}...`}
                  buttonText="Les mer"
                  buttonUrlLink={`/articles/${article.id}`}
                  downloadable={false}
                />
              </Col>
            ))}
          </StyledInfoBoxRow>
        )}
      </Row>
    </>
  );
};

export default Articles;
